import React from 'react';
import { useFormikContext } from 'formik';
import { ISelectOption, Select } from 'ui-toolkit';
import styled from 'styled-components';

interface IEditLenderClientProps {
  fieldName: string;
  options: ISelectOption<string>[];
  onChange: (value: string) => void;
}

const StyledEditLenderClient = styled(Select)`
  width: 100%;
  margin-right: ${(props) => props.theme.spacing.spacing2};
`;
export const EditLenderClient: React.FC<IEditLenderClientProps> = ({ fieldName, options, onChange }) => {
  const formik = useFormikContext<{}>();
  const transformValueToSelect = (value: any) => (options ? options.find((t) => t.value === value) : null);
  return (
    <StyledEditLenderClient
      value={transformValueToSelect(formik.values[fieldName])}
      backspaceRemovesValue={true}
      options={options}
      isClearable={false}
      onChange={(value: { value: string }) => onChange(value.value)}
      errorText={formik.errors[fieldName]}
      isRequired={true}
      placeholder={`Select one...`}
      data-test-id={fieldName}
      name={fieldName}
    />
  );
};
